import { createSelector } from 'reselect';
import getFutureOrderingLimitGeneric from './getFutureOrderingLimitGeneric';

import getOrdering from './getOrdering';

export default createSelector(
  [getOrdering, getFutureOrderingLimitGeneric],
  (ordering, futureOrderingLimitGenericFallback): number => {
    const { futureOrderingEnablePickup } = ordering.config;

    if (!futureOrderingEnablePickup) {
      return 0;
    }

    return (
      ordering.config.futureOrderingLimitPickup ||
      futureOrderingLimitGenericFallback
    );
  },
);
